import { connect } from 'react-redux';
import { Dispatch } from 'modules/store';
import * as Cache from 'modules/Cache';
import { ComponentProps } from 'utility/ComponentProps';
import { ViewChatPage } from 'components/ViewChatPage';

const mapDispatch = (dispatch: Dispatch) => ({
  _fetchPage: (chatID: number, minContentY: number, maxContentY: number) => {
    dispatch(
      Cache.syncObjectsWithinRange({ chatID, minContentY, maxContentY }) as any
    )
  }
});

type OwnProps = Pick<ComponentProps<typeof ViewChatPage>, 'chat'>;

function mergeProps(
  stateProps: {},
  { _fetchPage, ...dispatchProps }: ReturnType<typeof mapDispatch>,
  ownProps: OwnProps,
) {
  return {
    fetchObjects: (minContentY: number, maxContentY: number) => {
      _fetchPage(ownProps.chat.id, minContentY, maxContentY);
    },
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  };
}

const connector = connect(null, mapDispatch, mergeProps);

export default connector(ViewChatPage);
